import { render, staticRenderFns } from "./MisMateriasnew.vue?vue&type=template&id=028fb2d8&scoped=true"
import script from "./MisMateriasnew.vue?vue&type=script&lang=js"
export * from "./MisMateriasnew.vue?vue&type=script&lang=js"
import style0 from "./MisMateriasnew.vue?vue&type=style&index=0&id=028fb2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028fb2d8",
  null
  
)

export default component.exports